import Cookies from "js-cookie";
import Environment from "./Environment";
import { logError } from "./monitoring/clientUtilsNR";

/**
 * @class ServerStorage
 */
export class ServerStorage {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    get(key: string): string | undefined {
        return "";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    set(key: string, value: string) { }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setObj(key: string, value: Record<string, string | number | boolean> | string) { }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getObj(key: string): Record<string, string | number | boolean> | undefined {
        return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    remove(key: string) {}

}

export class ObjectStorage extends ServerStorage {

    getObj(key: string): Record<string, string | number | boolean> | undefined {
        try {
            const raw = this.get(key);

            return raw && JSON.parse(raw);
        } catch (err) {
            logError(err as Error, { msg: `failed to get key '${ key }' from localstorage` });

            return undefined;
        }
    }

    setObj(key: string, value: Record<string, string | number | boolean> | string): void {
        try {
            this.set(key, JSON.stringify(value));
        } catch (err) {
            logError(err as Error, { msg: `failed to save key '${ key }' to localstorage` });
        }
    }

}

/**
 * @class BrowserLocalStorage
 */
export class BrowserLocalStorage extends ObjectStorage {

    _namespace: string;

    constructor(namespace = "") {
        super();
        this._namespace = namespace;
    }

    get(key: string) {
        return window.localStorage.getItem(this._namespace + key) || "";
    }

    set(key: string, value: string) {
        window.localStorage.setItem(this._namespace + key, value);
    }

    remove(key: string) {
        window.localStorage.removeItem(this._namespace + key);
    }

}

/**
 *
 * @class BrowserSessionStorage
 */
export class BrowserSessionStorage extends ObjectStorage {

    _namespace: string;

    constructor(namespace = "") {
        super();
        this._namespace = namespace;
    }

    get(key: string) {
        return window.sessionStorage.getItem(this._namespace + key) || "";
    }

    set(key: string, value: string) {
        window.sessionStorage.setItem(this._namespace + key, value);
    }

    remove(key: string) {
        window.sessionStorage.removeItem(this._namespace + key);
    }

}

/**
 * @class BrowserCookieStorage
 */
export class BrowserCookieStorage extends ObjectStorage {

    _duration: number;

    constructor(duration = 1) {
        super();
        this._duration = duration;
    }

    get(key: string): string | undefined {
        return Cookies.get(key);
    }

    set(key: string, value: string) {
        Cookies.set(key, value, { expires: this._duration });
    }

    remove(key: string) {
        Cookies.remove(key);
    }

}

/**
 * @class Storage
 */
export class Storage {

    /**
     * Factory method for Storage
     *
     * @param {string} namespace prefix
     * @returns {ServerStorage|BrowserLocalStorage|BrowserCookieStorage}
     */
    static createLocalStorage(
        namespace?: string
    ): ServerStorage | BrowserLocalStorage | BrowserCookieStorage {
        if (!Environment.isBrowser()) {
            return new ServerStorage();
        }

        if (Environment.localStorageExists()) {
            return new BrowserLocalStorage(namespace);
        }

        if (Environment.cookiesAreEnabled()) {
            return new BrowserCookieStorage();
        }

        return new ServerStorage();
    }

    /**
     * @param namespace
     * @return {*}
     */
    static createSessionStorage(namespace?: string) {

        if (!Environment.isBrowser()) {
            return new ServerStorage();
        }

        if (Environment.sessionStorageExists()) {
            return new BrowserSessionStorage(namespace);
        }

        if (Environment.cookiesAreEnabled()) {
            return new BrowserCookieStorage();
        }

        return new ServerStorage();
    }

    static createCookieStorage(duration?: number) {

        if (!Environment.isBrowser()) {
            return new ServerStorage();
        }

        if (Environment.cookiesAreEnabled()) {
            return new BrowserCookieStorage(duration);
        }

        return new ServerStorage();
    }

}
